import { Title } from "views/components/Schedules/components/UpdateActivityPopup/styles";

const SpaceReservationTitle = ({
	students
}) => {
	const responsibleStudent = students.responsible;
    const title = `${responsibleStudent.name} (${responsibleStudent.id})`;
	return (
		<Title title={title}>{title}</Title>
	);
}

export default SpaceReservationTitle;